import React, { useState } from 'react'

import useFetch from 'hooks/useFetch'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { PdcaCycleForm } from './components'

import * as service from 'service'

const PdcaCycleShow = ({ match }) => {
  const { pdcaCycleId, pdcaId } = match.params
  const [loading, setLoading] = useState(false)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.pdca.showCycles,
    { pdcaId, pdcaCycleId },
    [pdcaId, pdcaCycleId],
  )

  const dataPdcaCicle = response?.data?.monitoringManagementPdcaCycle

  return (
    <Page title="Visualizar ciclo de PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={loading || isLoading} />
        <ContentHeader title="Visualizar ciclo de PDCA" />
        {!isLoading && (
          <PdcaCycleForm
            setLoading={setLoading}
            dataPdcaCicle={dataPdcaCicle}
            refresh={refresh}
            mode="show"
            pdcaId={pdcaId}
          />
        )}
      </Container>
    </Page>
  )
}

export default PdcaCycleShow
